export const COLLAPSED = 'collapsed';
export const EXPANDED = 'expanded';
export const RESIZE = 'resize';
export const CLICKED = 'clicked';

export const GET_NAVIGATION_CONFIG_REQUEST =
  'library/LanguageProvider/GET_NAVIGATION_CONFIG_REQUEST';
export const GET_NAVIGATION_CONFIG_SUCCESS =
  'library/LanguageProvider/GET_NAVIGATION_CONFIG_SUCCESS';
export const GET_NAVIGATION_CONFIG_FAILURE =
  'library/LanguageProvider/GET_NAVIGATION_CONFIG_FAILURE';

export const REQUEST = 'REQUEST';
export const COMPLETE = 'COMPLETE';
export const IDLE = 'IDLE';
export const SUCCESS = 'SUCCESS';
export const FAILURE = 'FAILURE';

export const L1IconWrapperSize = 85;
export const UrlWithFlashRegex = /([&?])flash(=[^&]*)?/g;

